import { useKidRoutes } from '@entities/customer'
import { WsEvent } from '@shared/api'

export const useStopListener = ($echo: any, name: string, channel: any): void => {
  const { isRouteHome } = useKidRoutes()

  onBeforeUnmount(() => {
    channel.stopListening(WsEvent.CustomerUpdated)
    channel.stopListening(WsEvent.DisciplineUpdated)
    channel.stopListening(WsEvent.FilesUpdated)
    if (isRouteHome.value) {
      channel.stopListening(WsEvent.BookingCreated)
      channel.stopListening(WsEvent.BookingUpdated)
      channel.stopListening(WsEvent.BookingDeleted)
      channel.stopListening(WsEvent.AssessmentCreated)
    }
    channel.stopListening(WsEvent.SubscriptionRetryFailed)
    channel.stopListening(WsEvent.SubscriptionRetrySuccessful)
    channel.stopListening(WsEvent.ProgressReportCreated)

    $echo.leave(name)
  })
}
